import {gql} from '@apollo/client';

export const timeTrackerQueries = {
    GET_ALL_TIME_TRACKER_ENTITIES: gql`
        query GetAllTimeTrackers(
            $after: String
            $first: Int
            $before: String
            $last: Int
            $where: TimeTrackerFilterInput
        ) {
            allTimeTrackers(after: $after, first: $first, before: $before, last: $last, where: $where) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    id
                    userInfo {
                        firstName
                        lastName
                    }
                    description
                    title
                    startTime
                    endTime
                    status
                    durationInSeconds
                    itemDataId
                    createdDate
                    ticketNo
                    itemDataURL
                }
                pageInfo {
                    endCursor
                    hasNextPage
                    hasPreviousPage
                    startCursor
                }
            }
        }
    `,
    GET_ALL_TIME_TRACKER_ENTITIES_WITH_OUT_PAGINATION: gql`
        query GetAllTimeTrackersWithOtherPagination($where: TimeTrackerFilterInput) {
            allTimeTrackersWithoutPagination(where: $where) {
                id
                description
                title
                startTime
                endTime
                status
                durationInSeconds
                itemDataId
                createdDate
                ticketNo
                itemDataURL
            }
        }
    `,
    GET_ONE_TRACKER_ENTITY_BY_ID: gql`
        query GetOneTimeTrackerEntity($where: TimeTrackerFilterInput) {
            oneTimeTrackerEntity(where: $where) {
                id
                description
                title
                startTime
                endTime
                status
                durationInSeconds
                itemDataId
                createdDate
                ticketNo
                itemDataURL
            }
        }
    `,
};
